import useOldLang from '../../hooks/useOldLang.ts';
import { callApi } from '../../api/gramjs/index.ts';
import { oldSetLanguage } from '../../util/oldLangProvider.ts';
import { getActions, withGlobal } from '../../global/index.ts';

export const myTestBtn = async()=>{
  await new Promise(resolve => setTimeout(resolve, 1));
  const dom = document.querySelector('body')
  console.log('dom=>',dom);
  const newEle = document.createElement('div')
  newEle.classList.add('myTestBtn2');
  newEle.textContent = '调试按钮';
  newEle.addEventListener('click', async(event) => {
    event.stopPropagation();
    const res = await Promise.all([
      // rootScope.managers.apiManager.invokeApiCacheable('langpack.getLanguage', {
      //   lang_pack: 'ios',//iOS 客户端的默认语言包。
      //   lang_code: 'en',
      // }),
      // rootScope.managers.apiManager.invokeApiCacheable('langpack.getLanguages', {
      //   lang_pack: 'ios',//iOS 客户端的默认语言包。
      // }),
      // rootScope.managers.apiManager.invokeApiCacheable('langpack.getLangPack', {
      //   lang_pack: 'web',//iOS 客户端的默认语言包。
      //   // lang_code: 'zh-hans',
      //   lang_code: 'en',
      // })
      // rootScope.managers.apiManager.invokeApi('account.getAuthorizations'),
      // rootScope.managers.apiManager.invokeApiCacheable('account.getAuthorizations'),
      // rootScope.managers.apiManager.invokeApi('messages.getDialogs',{
      //   limit: 100,
      //   offset_date: 0,
      //   offset_id: 0,
      //   offset_peer: { _: 'inputPeerEmpty' }
      // }),
    ])

    myTest1()
    // await myTest2()
    console.error('====================================================');
  });
  dom.appendChild(newEle);
}

const myTest1 = () => {
  // const lang = useOldLang();
  // const testLang = lang('Localization.InterfaceLanguage')
  // console.error('老铁双击666？？？',testLang);
  const { setSharedSettingOption, } = getActions();
  const langCode = 'zh'
  void oldSetLanguage(langCode, () => {
    setSharedSettingOption({ language: langCode });
  });
  
}

const myTest2 = async() => {
  return
  const query = {
    langPack: 'weba',
    langCode: 'zh'
  }
  const result = await callApi('justTestFun2', query);
  console.error('result=>',result);
}